/**
 * The locales and recording languages this build offers.
 *
 * `SUPPORTED_LOCALES` is what is catalogued; this is the subset switched on for
 * the environment the bundle was built for (the `locales` row of
 * `FEATURE_TABLE` in `@reflect/domain`). Everything that *offers* a language —
 * the switcher, the account pickers, `hreflang`, the cookie — reads these,
 * never the registry.
 */
import {
  liveLocales,
  liveRecordingLanguages,
  type Locale,
  type RecordingLanguage,
} from "@reflect/domain";

import { DEPLOY_ENV } from "../env";

/** The UI locales switched on in this build, default first. */
export const LIVE_LOCALES: readonly Locale[] = liveLocales(DEPLOY_ENV);

/** The recording languages switched on in this build. */
export const LIVE_RECORDING_LANGUAGES: readonly RecordingLanguage[] =
  liveRecordingLanguages(DEPLOY_ENV);
